import axios from 'axios';
import { AssetGoals } from '../type/AssetGoals.type';
import { useAssetGoalsStore } from '../stroe/AssetGoals.store';
import { LOCALFORAGE_YN, SERVER_URL } from '../../../common/comstant/CommonConstants';

export const useAssetGoalsAPI = () => {
  const { insertAssetGoalsToStore, getAssetGoalsListFromStore, deleteAssetGoalsAtStore } = useAssetGoalsStore();

  const insertAssetGoals = async (assetGoals: AssetGoals) => {
    if (LOCALFORAGE_YN) {
      return insertAssetGoalsToStore(assetGoals);
    } else {
      return axios.post<string>(`${SERVER_URL}/asset-goals`, assetGoals);
    }
  };

  const getAssetGoalsList = async () => {
    if (LOCALFORAGE_YN) {
      return getAssetGoalsListFromStore();
    } else {
      return axios.get<AssetGoals[]>(`${SERVER_URL}/asset-goals`);
    }
  };

  const deleteAssetGoals = async (id: string) => {
    if (LOCALFORAGE_YN) {
      return deleteAssetGoalsAtStore(id);
    } else {
      return axios.delete<AssetGoals>(`${SERVER_URL}/asset-goals/${id}`);
    }
  };

  return {
    insertAssetGoals,
    getAssetGoalsList,
    deleteAssetGoals,
  };
};
